/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom } from 'rxjs/operators';

import { EApiRequestStatus, SET_YOUR_PASSWORD_ROUTE_NAME } from '../../account-activation/models';
import { ResetAccountActivation } from '../../account-activation/store/actions';
import { getVerifyAccountRequestStatus } from '../../account-activation/store/selectors';
import { IUserState } from '../../account-activation/store/state';
import { NavigationGuard } from './navigation.guard';

@Injectable({
  providedIn: 'root'
})
export class VerifyAccountRequestGuard {
  constructor(
    private readonly store: Store<IUserState>,
    private readonly router: Router,
    private readonly navigationGuard: NavigationGuard
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.navigationGuard.canActivate(next, state).pipe(
      filter(isNavigatable => isNavigatable),
      withLatestFrom(this.store.pipe(select(getVerifyAccountRequestStatus))),
      map(([isNavigatable, verifyAccountRequestStatus]) => {
        if (verifyAccountRequestStatus !== EApiRequestStatus.Success) {
          this.store.dispatch(ResetAccountActivation());
          this.router.navigate([`/${SET_YOUR_PASSWORD_ROUTE_NAME}`]);
          return false;
        }

        return true;
      })
    );
  }
}
